import Icon from "@mdi/react";
import {mdiLoading} from "@mdi/js";
import React, {useEffect, useState} from "react";
import stiles from "./PricingPanel.scss"
import UELogo from "./UELogo";
import {connect} from "react-redux";
const PricingCollectiveFormRight = ({forms, selected})=>{



   useEffect(()=>{
        //console.log(selected)
   }, [selected])

    const renderItem=(item, index)=>{
        return <div key={index} className={item?.val?"ue-price-form-type":"ue-price-form-type active"}>
            <div>{
                    (item?.val)
                    ?<svg width="24" height="24" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8.5 0.777832C3.80587 0.777832 0 4.35983 0 8.77783C0 13.1965 3.80587 16.7778 8.5 16.7778C13.1941 16.7778 17 13.1965 17 8.77783C17 4.35983 13.1941 0.777832 8.5 0.777832ZM13.9924 7.15183L7.89579 12.8898C7.77113 13.0078 7.56854 13.0078 7.44458 12.8898L6.54358 12.0332C6.41962 11.9158 6.21633 11.7238 6.09308 11.6052L3.99642 9.5305C3.93479 9.4725 3.90221 9.3905 3.90221 9.3125C3.90221 9.23583 3.93479 9.16117 3.99642 9.10317L4.91512 8.32383C4.97746 8.26383 5.06033 8.2345 5.1425 8.2345C5.22325 8.23517 5.304 8.26517 5.36562 8.32383L7.44529 10.3205C7.56925 10.4392 7.77183 10.4392 7.8965 10.3205L12.6416 5.8665C12.7663 5.7485 12.9682 5.7485 13.0921 5.8665L13.9931 6.72317C14.1171 6.8405 14.1171 7.03383 13.9924 7.15183Z" fill="#58D2C3"/>
                        </svg>
                    :<svg width="24" height="24" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8 0.84668C3.581 0.84668 -2.38419e-07 4.42868 -2.38419e-07 8.84668C-2.38419e-07 13.2647 3.581 16.8467 8 16.8467C12.419 16.8467 16 13.2647 16 8.84668C16 4.42868 12.419 0.84668 8 0.84668ZM11.707 11.1397C12.098 11.5307 12.098 12.1627 11.707 12.5537C11.512 12.7487 11.256 12.8467 11 12.8467C10.744 12.8467 10.488 12.7487 10.293 12.5537L8 10.2607L5.707 12.5537C5.512 12.7487 5.256 12.8467 5 12.8467C4.744 12.8467 4.488 12.7487 4.293 12.5537C3.902 12.1627 3.902 11.5307 4.293 11.1397L6.586 8.84668L4.293 6.55368C3.902 6.16268 3.902 5.53068 4.293 5.13968C4.684 4.74868 5.316 4.74868 5.707 5.13968L8 7.43268L10.293 5.13968C10.684 4.74868 11.316 4.74868 11.707 5.13968C12.098 5.53068 12.098 6.16268 11.707 6.55368L9.414 8.84668L11.707 11.1397Z" fill="#FA8A8A"/>
                        </svg>
            }
                </div>
            <div className={"w-100 text-left ml-2"}>{item?.title}</div>
        </div>
   }



    return  <>
             <div className={"d-flex flex-column justify-content-between align-items-center bg-white rounded-lg shadow h-75"} style={{"color":"#70979A", "overflow": "auto"}}>
                <div className={"ue-pricing-form-header  w-100 text-center p-5"} >
                    <div className={"title h2 uppercase font-weight-bold my-3 text-center"}>{selected?.title}</div>
                    <div className={"description h4 my-3 text-center"}>{selected?.description}</div>

                </div>
                <div className={"ue-pricing-form-sample w-100 text-center py-2"}
                     onClick={()=>window.open(selected.url, '_blanck')}
                >
                        <div className={"h4 w-100 text-center my-2"}>Télécharger un modèle</div>
                    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"

                    >
                        <circle cx="12" cy="12" r="12" fill="#BDF4EE"/>
                        <path d="M15.8407 11.598L12.75 14.6895V6.75C12.75 6.336 12.414 6 12 6C11.586 6 11.25 6.336 11.25 6.75V14.6895L8.15926 11.5987C7.866 11.3055 7.39126 11.3055 7.09875 11.5987C6.80549 11.892 6.80549 12.3667 7.09875 12.6592L11.3415 16.902C11.5215 17.082 11.7675 17.1375 12.0008 17.0962C12.2333 17.1375 12.48 17.0812 12.66 16.902L16.9028 12.6592C17.196 12.366 17.196 11.8913 16.9028 11.5987C16.6087 11.3055 16.134 11.3055 15.8407 11.598Z" fill="#3FB9AA"/>
                    </svg>

                </div>
                <div className={"ue-pricing-form-footer w-100 p-5 "}>
                    {selected?.options?.length?selected.options.map((item,index)=>renderItem(item,index)):null}
                </div>

            </div>

            </>
}

const mapStateToProps = state => {
    return {
        idUser: state.MeReducer.id,
        entity: state.MeReducer.entity,
    }
}

const mapDispatchTProps = dispatch => {
    return {

    }
}

export default connect(mapStateToProps, mapDispatchTProps)(PricingCollectiveFormRight)

